module.exports = __webpack_public_path__ + "static/img/Utrecht.f39826f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Utrecht.jpg
// module id = xRoi
// module chunks = 1